<mat-accordion #accordion="matAccordion" [multi]="true">
  <!-- Thông tin tài liệu -->
  <mat-expansion-panel expanded="true" class="mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title class="document_info mat-panel-title">
        {{'title.document_info' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-container *ngIf="documentReference.length > 0">
      <strong> {{'form.doc_reference' | translate}} </strong>
      <br>
      <div *ngFor="let item of documentReference">
        <ins class="fix-width" style="cursor: pointer;" (click)="viewDocumentReference(item.id)"
             matTooltip="{{item.code}} - {{item.name}}">
          <em class="fa fa-file fa-fw text-primary"></em>
          {{item.code }} - {{item.name}}
        </ins>
      </div>
      <br>
    </ng-container>

    <ng-container>
      <div class="mt-1 mb-0">
        <strong> {{'form.service_type' | translate}} </strong>
        <br>
        <mat-label> {{document.serviceType}} </mat-label>
      </div>
    </ng-container>

    <ng-container>
      <div class="mt-1 mb-0">
        <strong> {{'form.doc_code' | translate}} </strong>
        <br>
        <mat-label> {{document.code}} </mat-label>
      </div>
    </ng-container>

    <ng-container>
      <div class="mt-1 mb-0">
        <strong> {{'form.doc_name' | translate}} </strong>
        <br>
        <mat-label> {{document.name}} </mat-label>
      </div>
    </ng-container>

    <ng-container>
      <div class="mt-1 mb-0">
        <strong> {{'form.expired_date' | translate}} </strong>
        <br>
        <mat-label> {{document.expiredDate | date: 'dd/MM/yyyy'}} </mat-label>
      </div>
    </ng-container>

    <ng-container>
      <div class="mt-1 mb-0">
        <strong> {{'form.status' | translate}} </strong>
        <br>
        <ng-container>
          <nz-tag *ngIf="document.status == 1">{{'search_form.draft' | translate}}</nz-tag>
          <nz-tag *ngIf="document.status == 2" [nzColor]="'blue'">{{'search_form.processing' | translate}}</nz-tag>
          <nz-tag *ngIf="document.status == 3" [nzColor]="'red'">{{'search_form.denied_sign' | translate}}</nz-tag>
          <nz-tag *ngIf="document.status == 4" [nzColor]="'green'">{{'search_form.signed' | translate}}</nz-tag>
          <nz-tag *ngIf="document.status == 5" [nzColor]="'red'">Đã huỷ</nz-tag>
          <nz-tag *ngIf="document.status == 2" [nzColor]="'orange'">Chờ set luồng ký</nz-tag>
        </ng-container>
      </div>
    </ng-container>
    <hr>
  </mat-expansion-panel>

  <!-- Danh sách tệp đính kèm -->
  <!-- BEGIN: Updated for change request SCONTRACT-5260 and reverted previous version-->
  <mat-expansion-panel class="mat-elevation-z0" expanded="false">
    <mat-expansion-panel-header>
      <mat-panel-title class="document_info mat-panel-title">
        {{'form.attach_file_list' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- Customer's attachments -->
    <div class="mt-2 fix-width" *ngFor="let item of document.contractAttachments">
      <a (click)="downloadFile(item.id, item.fileName)">
        <em class="fa fa-download fa-fw text-primary" matTooltip="{{'tooltips.download' | translate}}"></em>
      </a>
      <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
    </div>
    <!-- New uploads -->
    <div class="mt-2 fix-width" *ngFor="let item of document.newUploadContractAttachments">
      <a (click)="downloadFile(item.id, item.fileName)">
        <em class="fa fa-download fa-fw text-primary" matTooltip="{{'tooltips.download' | translate}}"></em>
      </a>
      <span [matTooltip]="item.fileName"> {{item.fileName}}</span>
    </div>
    <span style="color:#858796; font-size: 14px;"
          *ngIf="document.contractAttachments.length == 0 && document.newUploadContractAttachments.length == 0">
      {{'form.document_not_found' | translate}}
    </span>
    <hr/>
  </mat-expansion-panel>
  <!-- END: Updated for change request SCONTRACT-5260 -->

  <!-- Luồng Duyệt/Ký -->
  <mat-expansion-panel expanded="true" class="mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title font-color-blue">
        {{'form.order_of_approval_signing_contract_unit' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="table-user-element" style="overflow: auto;">
      <nz-table #listEnterpriseSignTable nzSize="middle" [nzData]="listEnterpriseSign" [nzShowPagination]="false"
                [nzBordered]="true">
        <thead>
        <tr>
          <th>TT</th>
          <th>Tên chủ thể</th>
          <th>Email</th>
          <th>SĐT</th>
          <th>{{'form.status' | translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of listEnterpriseSignTable.data">
          <td>{{ data.order }}</td>
          <td>{{ data.enterpriseName }}</td>
          <td>{{ data.enterpriseEmail }}</td>
          <td>{{ data.enterprisePhone }}</td>
          <td>
            <ng-container [ngSwitch]="data.status">
              <div class="mt-1 mb-0">
                <ng-container>
                  <nz-tag *ngSwitchCase="1">{{'search_form.draft' | translate}}</nz-tag>
                  <nz-tag *ngSwitchCase="2" [nzColor]="'blue'">{{'search_form.processing' | translate}}</nz-tag>
                  <nz-tag *ngSwitchCase="3" [nzColor]="'red'">{{'search_form.denied_sign' | translate}}</nz-tag>
                  <nz-tag *ngSwitchCase="4" [nzColor]="'green'">{{'search_form.signed' | translate}}</nz-tag>
                  <nz-tag *ngSwitchCase="5" [nzColor]="'red'">Đã huỷ</nz-tag>
                  <nz-tag *ngSwitchCase="6" [nzColor]="'orange'">Chờ thiết lập luồng</nz-tag>
                </ng-container>
              </div>
            </ng-container>
          </td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </mat-expansion-panel>
  <!-- Nz-table set luồng ký / duyệt-->
  <mat-expansion-panel expanded="true" class="mat-elevation-z0">
    <mat-expansion-panel-header>
      <mat-panel-title class="mat-panel-title font-color-blue">
        {{'form.order_of_approval_signing_contract_unit' | translate}}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- <button nz-button (click)="addRow()" nzType="primary">Add</button> -->
    <br/>
    <nz-table #editRowTable nzBordered [nzData]="RECORD_USER_PERFORM_SIGN" nzShowPagination=false>
      <thead>
      <tr>
        <th class="text-center">TT</th>
        <th nzWidth="50%">Tên</th>
        <th>Thực hiện</th>
        <th>&nbsp;</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of editRowTable.data; let i = index" class="editable-row">
        <!-- TT -->
        <td class="text-center">{{ i + 1 }}</td>
        <!-- Tên -->
        <td>
          <div class="editable-cell" *ngIf="data.userId != null">
            {{ data.userName }} - {{ data.userEmail }}
          </div>
        </td>

        <!-- Thực hiện -->
        <td>
          <div *ngIf="data.userId != null">
            <nz-radio-group nzName="radiogroup{{i}}" [(ngModel)]="data.userRole"
                            [ngModelOptions]="{ standalone: true }">
              <label nz-radio nzValue="2">Duyệt</label>
              <label nz-radio nzValue="1">Ký</label>
            </nz-radio-group>
          </div>
        </td>

        <!-- Action -->
        <td class="td-nz-icon text-center">
          <a *ngIf="data.userId != null" nz-popconfirm nzPopconfirmTitle="Sure to delete?"
             (nzOnConfirm)="onClickDeleteElementRecordUser(data.userId)">
            <i nz-icon nzType="close-square" nzTheme="outline" nzTooltipTitle="Delete"></i>
          </a>
        </td>
      </tr>
      <tr class="editable-row">
        <!-- TT -->
        <td class="text-center">&nbsp;</td>
        <!-- Tên -->
        <td>
          <div>
            <nz-input-group [nzSuffix]="suffixIconSearch">
              <input nz-input [(ngModel)]="inputUserValue" (input)="onChangeUserSignSearch($event.target?.value)"
                     [nzAutocomplete]="auto"
                     placeholder="{{'placeholder.name_and_email' | translate}}"/>
            </nz-input-group>
            <ng-template #suffixIconSearch>
              <nz-spin nzSimple [nzIndicator]="indicatorTemplate" [nzSpinning]="isLoadUserSign"></nz-spin>
            </ng-template>
            <ng-template #indicatorTemplate>
              <i nz-icon nzType="loading" style="font-size: 14px;"></i>
            </ng-template>
            <nz-autocomplete #auto>
              <nz-auto-option *ngFor="let user of filteredUserOptions"
                              (selectionChange)="autocompleteUserSelected($event, user)"
                              [nzValue]="user">{{user.fullName}} - {{user.email}}</nz-auto-option>
            </nz-autocomplete>
          </div>
        </td>

        <!-- Thực hiện -->
        <td>
          <div>
            <nz-radio-group nzName="radiogroupDefault" [(ngModel)]="valueSelectedUserRole"
                            [ngModelOptions]="{ standalone: true }">
              <label nz-radio nzValue="2">Duyệt</label>
              <label nz-radio nzValue="1">Ký</label>
            </nz-radio-group>
          </div>
        </td>

        <!-- Action -->
        <td class="td-nz-icon text-center">&nbsp;</td>
      </tr>
      </tbody>
    </nz-table>
    <mat-error *ngIf="isValidNoUserExist">
      {{'validation.error_user_no_set_up' | translate}}
    </mat-error>
    <mat-error *ngIf="isValidExistingSigning">
      {{'messages.error_user_no_set_up' | translate}}
    </mat-error>
    <button (click)="onSaveSignFlow()" nz-button nzType="primary">Lưu luồng ký</button>
  </mat-expansion-panel>
</mat-accordion>
